export default __webpack_public_path__ + "static/differential-scroll-04-a3f55a3f7c2822aae15b72d00b0485c1.jpg";